import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { AngleBackIcon, CloseIcon } from '@/components/UI/Icons/Icons';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const DeleteAdModalDescriptionHead = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 10px;
  height: fit-content;
  margin-bottom: 30px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 60px;
    padding-top: 15px;
    margin-bottom: 10px;
  }
`;

export const DeleteAdModalDescriptionHeadButton = styled(Button).attrs({
  appearance: 'primaryText',
  hasPadding: false,
})`
  border: 0;
`;

export const DeleteAdModalDescriptionBackIcon = styled(AngleBackIcon).attrs(
  ({ theme }) => ({
    fill: theme.palette.secondary.labels,
  })
)`
  height: 20px;
  width: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 18px;
    width: 10px;
  }
`;

export const DeleteAdModalDescriptionTitle = styled(Typography.Title).attrs({
  $variant: '4',
})`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
    font-weight: 500;
    text-align: center;
  }
`;

export const DeleteAdModalDescriptionCloseIcon = styled(CloseIcon).attrs(
  ({ theme }) => ({
    fill: theme.palette.secondary.labels,
  })
)`
  height: 20px;
  width: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 15px;
    width: 15px;
  }
`;

export const DeleteAdModalPopupContent = styled.div`
  padding: 40px 50px 0;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 25px 20px 0;
  }
`;

export const DeleteAdModalPopupTitle = styled(Typography.Header)`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
  }
`;

export const DeleteAdModalPopupDescription = styled(Typography.Body)`
  padding: 10px 0 20px;
  text-align: center;
  color: ${({ theme }) => theme.palette.secondary.labels};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 0 30px;
    font-size: 16px;
  }
`;

export const DeleteAdModalPopupActions = styled.div`
  display: flex;
  gap: 10px;
  padding: 0 50px 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 20px 20px;
  }
`;

export const DeleteAdModalButton = styled(Button).attrs({
  isFullWidth: true,
  borderRadius: 14,
})<{ $hasMargin?: boolean; $isDescriptionView?: boolean }>`
  ${({ $hasMargin, $isDescriptionView }) =>
    $hasMargin &&
    css`
      margin: 30px 0 10px;

      @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        margin: ${$isDescriptionView ? '10px 0 20px 0' : '20px 0'};
      }
    `}
`;

export const DeleteAdModalListItem = styled.div`
  margin: 0 -15px;
  padding: 0 15px;

  &:first-child {
    margin-top: 10px;
  }

  &:last-of-type {
    margin-bottom: -10px;
  }
`;
